import type { AccessLogUser, AccessRecordPageResponse, AccessRecordResponse } from '@anery/api-contracts';

import { parseInstante } from '../../../shared/dominio/datas';
import type { PaginaDaTrilha, RegistroDeAcesso, UsuarioDaTrilha } from './tipos';

export function mapearRegistroDeAcesso(bruto: AccessRecordResponse): RegistroDeAcesso {
  return {
    id: bruto.id,
    ocorridoEm: parseInstante(bruto.occurredAt),
    tipoDeAtor: bruto.actorType,
    usuarioId: bruto.userId ?? null,
    login: bruto.userLogin ?? '—',
    papel: bruto.role ?? null,
    acao: bruto.action,
    recurso: bruto.resource,
    recursoId: bruto.resourceId ?? null,
    casoId: bruto.caseId ?? null,
    ticketId: bruto.ticketId ?? null,
    metodo: bruto.method ?? '',
    rota: bruto.route ?? '',
    status: bruto.statusCode,
    ip: bruto.ipAddress ?? null,
    correlationId: bruto.correlationId,
    duracaoMs: bruto.durationMs,
  };
}

export function mapearPaginaDaTrilha(bruto: AccessRecordPageResponse): PaginaDaTrilha {
  return {
    itens: (bruto.items ?? []).map(mapearRegistroDeAcesso),
    total: bruto.total,
  };
}

export function mapearUsuarioDaTrilha(bruto: AccessLogUser): UsuarioDaTrilha {
  return {
    id: bruto.id,
    login: bruto.login ?? '',
    nome: bruto.displayName ?? bruto.login ?? bruto.id,
  };
}
